// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"76581652","53":"e84322a7","217":"67bc0d21","337":"79e802ac","451":"0a1be5d9","510":"05d5848f","604":"189c15fe","622":"8113b1a5","708":"19ef00b9","743":"6ad3fe4f","751":"42e22c09","791":"6834875e","800":"dc0d4a05","821":"938eb88d","827":"978e3851"}[chunkId] + ".chunk.js";
};